var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2810_11770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04146 10.9999C10.4443 10.9999 11.5815 9.86273 11.5815 8.45992C11.5815 7.05712 10.4443 5.91992 9.04146 5.91992C7.63866 5.91992 6.50146 7.05712 6.50146 8.45992C6.50146 9.86273 7.63866 10.9999 9.04146 10.9999Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4317 16.5401C12.4317 14.6301 10.8817 13.0801 8.97172 13.0801C7.06172 13.0801 5.51172 14.6301 5.51172 16.5401",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9116 0.73999H4.18162C2.51372 0.73999 1.16162 2.09209 1.16162 3.75999V18.24C1.16162 19.9079 2.51372 21.26 4.18162 21.26H13.9116C15.5795 21.26 16.9316 19.9079 16.9316 18.24V3.75999C16.9316 2.09209 15.5795 0.73999 13.9116 0.73999Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2810_11770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.77,
    height: 21.52,
    fill: "white",
    transform: "translate(0.661621 0.23999)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationDashboard);
export default __webpack_public_path__ + "static/media/application_dashboard.ab92aee525950512c50c3f46666a934e.svg";
export { ForwardRef as ReactComponent };